<template>
  <div
    id="tolstoy-container"
    style="
      line-height: 0;
      overflow: hidden;
      height: 100%;
      width: 100%;
      text-align: center;
    "
  >
    <iframe
      :src="url"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
    ></iframe>

    <!-- <iframe
      id="tolstoy"
      :src="url"
      scrolling="no"
      frameborder="0"
      allow="autoplay *; clipboard-write *;camera *; microphone *; encrypted-media *; fullscreen *; display-capture *;"
    >
    </iframe> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      player: null,
    };
  },
  props: {
    url: String,
    autoplay: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    if (this.autoplay) {
      this.url = this.url + "&autoplay=1";
    }
  },
};
</script>
